import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { MovingSpriteView } from '../../ui_canvas_engine/MovingSpriteView.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIGameBeginnerModeGuideBubble } from '../ui_game_beginner_mode/UIGameBeginnerModeGuideBubble.ts';
import { GameColor } from '@colonist/ui-game';
import { Point } from '@colonist/game-mechanic-validators';
import { robberSkinController } from '../UIGameRobberSkinController.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameMapRobberController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.MapStateUpdated:
                this.updateRobber(data);
                break;
            case UIGameEventEnums.BeginnerModeStart:
                this.onBeginnerModeStart();
                break;
            default:
                break;
        }
    }
    buildTipContent() {
        const robberTipTitle = {
            key: 'strings:game.tips.robber.title'
        };
        const robberTipBody = [
            {
                key: 'strings:game.tips.robber.body.0'
            },
            {
                key: 'strings:game.tips.robber.body.1'
            }
        ];
        const bodyPrefixes = [
            undefined,
            undefined
        ];
        const nextPlayerColor = this.uiGameManager.gameController.currentStateValidator.nextPlayerToMoveRobber;
        if (nextPlayerColor != undefined) {
            const nextPlayerValidator = this.uiGameManager.gameController.getPlayerValidatorsMap().get(nextPlayerColor);
            if (nextPlayerValidator != undefined) {
                robberTipBody.push({
                    key: 'strings:game.tips.rushNextRobber.body.1'
                });
                bodyPrefixes.push({
                    text: {
                        key: 'strings:game.tips.rushNextRobber.body.username',
                        options: {
                            playerUsername: nextPlayerValidator.userState.username
                        }
                    },
                    color: GameColor.getPlayerBGDarkHashForMobile(nextPlayerColor)
                });
            }
        }
        return {
            title: robberTipTitle,
            body: robberTipBody,
            bodyPrefixes: bodyPrefixes
        };
    }
    updateRobber(animate) {
        const robberTile = this.uiGameManager.gameState.mapState.tileState.tiles[this.robberState.locationTileIndex];
        if (robberTile == undefined) return;
        if (this.lastRobberTile.sameTileHex(robberTile)) return;
        this.moveRobber(robberTile, animate);
    }
    moveRobber(tile, animate) {
        this.setZIndexToTopLayer();
        const robberCoords = this.getRobberCoords(tile);
        this.robberView.animationController.animationCompleteCallBack = ()=>{
            this.setZIndexToRobberLayer();
            if (animate) AudioManager.play(AudioType.RobberPlace);
            this.redrawGuideBubble();
        };
        this.robberView.animationController.animateTo(robberCoords);
        this.lastRobberTile = tile;
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.RobberMoved);
    }
    setZIndexToTopLayer() {
        this.robberView.zIndex = this.uiGameManager.mapController.mapView.layers.topLayer;
        this.uiGameManager.mapController.mapView.sortChildren();
    }
    setZIndexToRobberLayer() {
        this.robberView.zIndex = this.uiGameManager.mapController.mapView.layers.robber;
        this.uiGameManager.mapController.mapView.sortChildren();
    }
    getRobberCoords(tile) {
        const tileCenter = tile.hexFace.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2);
        const x = tileCenter.x - this.uiGameManager.mapController.mapView.robberRadius * 1.2;
        const y = tileCenter.y - this.uiGameManager.mapController.mapView.robberRadius * 0.7;
        return new Point(x, y);
    }
    onBeginnerModeStart() {
        if (this.robberView == undefined) return;
        this.guideBubbleView = new UIGameBeginnerModeGuideBubble(this.uiGameManager, this.robberView);
        this.uiGameManager.toolTipController.disableTip(this.robberView);
        this.robberView.texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_robber_tie);
    }
    redrawGuideBubble() {
        if (this.guideBubbleView == undefined) return;
        const currentBeginnerModeAction = this.guideBubbleView.currentBeginnerModeAction;
        this.guideBubbleView.destroy();
        this.guideBubbleView = new UIGameBeginnerModeGuideBubble(this.uiGameManager, this.robberView);
        this.guideBubbleView.currentBeginnerModeAction = currentBeginnerModeAction;
    }
    constructor(uiGameManager, robberState){
        this.uiGameManager = uiGameManager;
        this.robberState = robberState;
        const tileWithRobber = this.uiGameManager.gameState.mapState.tileState.tiles[this.robberState.locationTileIndex];
        if (tileWithRobber == undefined) return;
        this.lastRobberTile = tileWithRobber;
        const robberCoords = this.getRobberCoords(this.lastRobberTile);
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(robberSkinController.getRobberSkin());
        this.robberView = new MovingSpriteView(robberCoords.x, robberCoords.y, this.uiGameManager.mapController.mapView.robberRadius, this.uiGameManager.mapController.mapView.robberRadius, this.uiGameManager.mapController.mapView, texture);
        this.setZIndexToRobberLayer();
        this.robberView.animationController.animationCompleteCallBack = ()=>{
            this.setZIndexToRobberLayer();
        };
        const robberTipTitle = {
            key: 'strings:game.tips.robber.title'
        };
        const robberTipBody = [
            {
                key: 'strings:game.tips.robber.body.0'
            },
            {
                key: 'strings:game.tips.robber.body.1'
            }
        ];
        this.robberView.setTip(robberTipTitle, robberTipBody, ()=>this.buildTipContent());
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
